import { render, staticRenderFns } from "./index.vue?vue&type=template&id=96db7196&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./Index.scss?vue&type=style&index=0&id=96db7196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96db7196",
  null
  
)

export default component.exports